export const NEW_VALUES_FORM_ID = 'replaceMeterNewValuesStepForm';
